import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AlertController } from '@ionic/angular';
import { environment } from '../../../environments/environment';

interface VersionJson { version: string; buildTime: string; }

@Injectable({ providedIn: 'root' })
export class VersionCheckService {
  readonly currentVersion: string = environment.version;
  private reloadPromptShown = false;
  private intervalId: ReturnType<typeof setInterval> | null = null;

  constructor(private http: HttpClient, private alertCtrl: AlertController) {}

  checkVersion(): void {
    this.http.get<VersionJson>(`/assets/version.json?t=${Date.now()}`).subscribe({
      next: (data) => {
        if (data?.version && data.version !== this.currentVersion) {
          this.promptReload();
        }
      },
      error: (err) => console.warn('[VersionCheck]', err.message)
    });
  }

  async promptReload(): Promise<void> {
    if (this.reloadPromptShown) return;
    this.reloadPromptShown = true;

    const alert = await this.alertCtrl.create({
      header: 'Nouvelle version disponible',
      message: 'Une mise à jour est disponible. Rechargez pour en bénéficier.',
      backdropDismiss: false,
      buttons: [
        { text: 'Plus tard', role: 'cancel', handler: () => { this.reloadPromptShown = false; } },
        { text: 'Recharger', handler: () => window.location.reload() }
      ]
    });
    await alert.present();
  }

  startPolling(intervalMs = 5 * 60 * 1000): void {
    this.stopPolling();
    this.checkVersion();
    this.intervalId = setInterval(() => this.checkVersion(), intervalMs);
  }

  stopPolling(): void {
    if (this.intervalId !== null) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
  }
}
